module.exports = __webpack_public_path__ + "img/pedir.1ee115a2.png";